// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';



const swiper = new Swiper('.landing-page-hero .swiper', {
    modules: [Navigation],
    // Optional parameters
    loop: false,
    slidesPerView: 1,
    spaceBetween: 40,
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1000: {
            slidesPerView: 3,
        },

    },
    on: {
        // resize: function (swiper) {
        //     let $el = $(swiper.el);
        //     console.log('--------------------');
        //     console.log(swiper);
        //     console.log($(swiper.el).find('.swiper-slide'));
        //     swiper.updateSize();
        //     swiper.updateAutoHeight(100);

        // }
    },

    // If we need pagination


    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const swiperCustomNews = new Swiper('.block-custom-news .swiper', {
    modules: [Pagination],
    // Optional parameters
    loop: false,
    slidesPerView: 1,
    spaceBetween: 40,
    breakpoints: {
        // when window width is >= 640px
        768: {
            slidesPerView: 2,
        },
        850: {
            slidesPerView: 3,
        }
    },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination'
    },

    // Navigation arrows
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
});

const swiperCaseStudies = new Swiper('.block-case-studies .swiper', {
    modules: [Navigation],
    // Optional parameters
    loop: false,
    slidesPerView: 1,
    spaceBetween: 40,

    // If we need pagination


    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});


const swiperJobstack = new Swiper('.jobstack-slider .swiper', {
    modules: [Navigation],
    loop: false,
    cssMode: true,
    slidesPerView: 1.1,
    spaceBetween: 20,
    navigation: {
        nextEl: '.slider-next',
        prevEl: '.slider-prev',
    },
    breakpoints: {
        576: {
            slidesPerView: 1.9,
        },
        992: {
            slidesPerView: 2.9,
            spaceBetween: 30,
        },
        1400: {
            slidesPerView: 3.9,
        }
    },
});
